/**
 * Labstep
 *
 * @module components/NotificationAlert/Action/Set
 * @desc Action to set notification alert
 */

import { NotificationAlertActionCreate } from 'labstep-web/components/NotificationAlert/Action/Create';
import { NotificationAlertDetails } from 'labstep-web/components/NotificationAlert/Details';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { PopupContainer as Popup } from 'labstep-web/core/Popup';
import type React from 'react';
import { useState } from 'react';
import type { NotificationAlertActionSetProps } from './types';

export const NotificationAlertActionSet: React.FC<
  NotificationAlertActionSetProps
> = ({ metadata }) => {
  const [open, setOpen] = useState(!metadata.hasActiveAlert);

  if (metadata.hasActiveAlert) {
    return (
      <Popup
        on="click"
        inverted={false}
        flowing
        open={open}
        onClose={() => setOpen(false)}
        trigger={
          <ActionComponent
            type="icon"
            onClick={() => setOpen(true)}
            elementProps={{
              name: 'bell',
              color: metadata.hasAlertFired ? 'red' : 'yellow',
              popup: {
                content: metadata.hasAlertFired ? (
                  <>
                    <div>{`Alert! ${
                      metadata.notification_alert?.message || ''
                    }`}</div>
                    <div>Click to edit.</div>
                  </>
                ) : (
                  <>
                    <div>{metadata.alertTriggerTime}</div>
                    <div>Click to edit.</div>
                  </>
                ),
              },
            }}
          />
        }
        content={<NotificationAlertDetails metadata={metadata} />}
      />
    );
  }
  return <NotificationAlertActionCreate metadata={metadata} />;
};
